// Cégjegyzékszám
export default function() {
  return /^(20|[0-1][0-9])[\- ](20|21|22|23|[0-1][0-9])[\- ]([0-9]{8})$/;
};